/** 平台内部店铺类型码（中文）→ workbench.shopTypeLabel。value 仍传中文码，只换展示。 */
const SHOP_TYPE_KEYS = {
  半托管: 'shopTypeLabel.semi',
  全托管: 'shopTypeLabel.full',
  本土: 'shopTypeLabel.local',
  自运营: 'shopTypeLabel.self',
  跨境: 'shopTypeLabel.crossborder',
};

export function localizedShopTypeLabel(t, shopType) {
  const raw = String(shopType || '').trim();
  const key = SHOP_TYPE_KEYS[raw];
  if (!key || typeof t !== 'function') return raw;
  return t(key, { defaultValue: raw });
}
